export const EXPORT_INLINE_STYLE_PROPERTIES = [
	'align-items',
	'background-color',
	'border',
	'border-bottom',
	'border-left',
	'border-radius',
	'border-right',
	'border-top',
	'box-sizing',
	'color',
	'direction',
	'display',
	'flex',
	'flex-direction',
	'flex-wrap',
	'font-family',
	'font-size',
	'font-style',
	'font-weight',
	'gap',
	'height',
	'justify-content',
	'left',
	'letter-spacing',
	'line-height',
	'list-style-position',
	'list-style-type',
	'margin',
	'margin-bottom',
	'margin-left',
	'margin-right',
	'margin-top',
	'max-height',
	'max-width',
	'min-height',
	'min-width',
	'overflow',
	'padding',
	'padding-bottom',
	'padding-left',
	'padding-right',
	'padding-top',
	'position',
	'right',
	'table-layout',
	'text-align',
	'text-decoration',
	'top',
	'transform',
	'transform-origin',
	'unicode-bidi',
	'vertical-align',
	'white-space',
	'width',
	'word-break'
];


